import React from 'react';
import { AtlassianLogo } from '@atlaskit/logo';
import config from 'appconfig';

export default () => (
  <a href={`${config.wacUrl}`}>
    <AtlassianLogo />
  </a>
);
